import * as h2Api from '../../js/h2Api'

export const SEARCH_DEPLOYMENTS = 'SEARCH_DEPLOYMENTS'
export const LIST_DEPLOYMENTS = 'LIST_DEPLOYMENTS'

export const listDeployments = () => dispatch => {
  return dispatch(h2Api.get('/marketing/deployments')({ type: LIST_DEPLOYMENTS }))
}

export const searchDeployment = searchTerm => dispatch => {
  return dispatch(
    h2Api.post('/marketing/deployments/search', { searchTerm })({
      type: SEARCH_DEPLOYMENTS
    })
  )
}
